import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-head",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  }
};